module.exports = __webpack_public_path__ + "static/media/starOff_118.1cfb443c.png";